import { render, staticRenderFns } from "./EditNotification.vue?vue&type=template&id=5f1dc48f&"
import script from "./EditNotification.vue?vue&type=script&lang=js&"
export * from "./EditNotification.vue?vue&type=script&lang=js&"
import style0 from "./EditNotification.vue?vue&type=style&index=0&id=5f1dc48f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports